import { graphql, HttpResponse } from 'msw'
import { type EnrollmentSuitabilityData, type EnrollmentSuitabilitySubmitOutput } from '../../../models'

export const getEnrollmentSuitabilityDataMock: EnrollmentSuitabilityData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/personal-info',
  enrollmentData: {
    userInfo: {
      investment: {
        isBrokerDealer: true,
        isDirectorPolicyMakerOfCompany: true,
        directorPolicyMakerOfCompany: 'TSLA',
      },
    },
  },
}

export const submitEnrollmentSuitabilityDataMock: EnrollmentSuitabilitySubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/filing-status',
  enrollmentData: {
    userInfo: {
      investment: {
        isBrokerDealer: true,
        isDirectorPolicyMakerOfCompany: true,
        directorPolicyMakerOfCompany: 'TSLA',
      },
    },
  },
}

export const mockGetEnrollmentSuitabilityData = graphql.mutation('getEnrollmentSuitabilityData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentSuitabilityDataMock } })
})

export const mockSubmitEnrollmentSuitabilityData = graphql.mutation('submitEnrollmentSuitabilityData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentSuitabilityDataMock } })
})

export const mockEnrollmentSuitability = [mockGetEnrollmentSuitabilityData, mockSubmitEnrollmentSuitabilityData]
